// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interaction[data-v-f1482f1e]{-webkit-overflow-scrolling:touch;overflow-y:auto;flex-grow:1;display:flex;position:relative;height:100%}.interaction img[data-v-f1482f1e]{max-width:100%}.fade-leave[data-v-f1482f1e]{opacity:1!important}.fade-leave-to[data-v-f1482f1e]{opacity:0!important}", ""]);
// Exports
module.exports = exports;
